<template>
    <div class="layout-top">
        <Layout>
            <Header :style="{zIndex: '999',  position: 'fixed', width: '100%',backgroundColor:'white',minWidth:'80%' }">
                <div style="display: flex; justify-content: space-between; width: 220px;">
                    <img @click="toIndex" class="logo" :src="userInfo.ext_info.logo">
                    <Poptip v-model="visible" placement="bottom" width="200" @on-popper-hide="iconShow = false" v-if="userInfo.role_type == 4 || userInfo.role_type == 5 || userInfo.role_type == 1 || userInfo.role_type == 2">
                        <Badge>
                            <div style="display: flex;">
                                <div style=" text-align: center; display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;">
                                    {{topShowName}}
                                </div>
                                <span v-show="iconShow" @click="iconShow = !iconShow"
                                      class="icon iconfont icon-up"></span>
                                <span v-show="!iconShow" @click="iconShow = !iconShow"
                                      class="icon iconfont icon-down2"></span>
                            </div>
                        </Badge>
                        <div slot="content">
                            <div style="position: relative; display: flex; justify-content: center;">
                                <Tabs :value="tabsValue">
                                    <TabPane label="部门" name="department" v-if="userInfo.role_type == 4 || userInfo.role_type == 5">
                                        <div style="max-height: 200px; overflow: auto;">
                                            <div style="cursor: pointer;display: flex; justify-content: center;" @click="chooseDepartment" v-for="(item,index) in departmentList"
                                                 :data-id="item.id" :data-name="item.name">
                                                {{item.name}}
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane label="个人" name="personal" v-if="userInfo.role_type == 4 || userInfo.role_type == 5">
                                        <div style="max-height: 200px; overflow: auto;">
                                            <div style="display: flex; justify-content: center; "
                                                 v-for="(user,index) in departmentUserList" :key="index">
                                                <div style="cursor: pointer;" @click="chooseUser" :data-id="user.id"
                                                     :data-name="user.name">{{user.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane label="请选择分公司" name="shop" v-if="userInfo.role_type == 1 || userInfo.role_type == 2">
                                        <div style="max-height: 200px; overflow: auto;">
                                            <div style="display: flex; justify-content: center; "
                                                 v-for="(shop,index) in shopList" :key="index">
                                                <div style="cursor: pointer;" @click="chooseShop" :data-id="shop.id" :data-token="shop.token"
                                                     :data-name="shop.name">{{shop.name}}
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </Poptip>
                </div>
                <!--Menu @on-select='selectFirstMenu' theme="light" mode="horizontal" :active-name="activeMenu">
                    <div class="layout-nav">
                        <MenuItem v-for="(item,index) in userInfo.menuList" :name="item.key" :key="index">
                            <Badge class-name="my_badge" v-if="item.key == 'client'" :offset="[99,0]" :count="userInfo.userNotice.clientUndeal">
                                {{item.name}}
                            </Badge>
                            <Badge class-name="my_badge" v-else-if="item.key == 'task'" :offset="[99,0]" :count="userInfo.userNotice.taskUndeal">
                                {{item.name}}
                            </Badge>
                            <Badge class-name="my_badge" v-else-if="item.key == 'mareLiberum'" :offset="[99,0]" :count="userInfo.userNotice.mareLiberum">
                                {{item.name}}
                            </Badge>
                            <span v-else>{{item.name}}</span>
                        </MenuItem>
                    </div>
                </Menu-->
                <div class="top-right">
                    <div v-if="userInfo.menuList.homePage" style=" margin-right: 5px;">
                        <Poptip class="margin_flex" placement="bottom" width="450" v-if="userInfo.menuList.homePage.teamNotice">
                            <Badge  :count="userInfo.userNotice.sum">
                                <a href="javascript:void(0)"><span class="icon iconfont icon-lingdang"></span></a>
                            </Badge>
                            <div slot="content">
                                <div style="position: relative;">
                                    <Tabs value="name1">
                                        <TabPane label="未读通知" name="name1">
                                            <div style="display: flex; align-items: center; margin-bottom: 20px;" v-if="userInfo.userNotice.lastNoReadNotice.noticeContent">
                                                <img :src="userInfo.userNotice.lastNoReadNotice.logo"
                                                     style="width: 40px;"/>
                                                <div style="margin-left: 10px;">
                                                    <div>{{userInfo.userNotice.lastNoReadNotice.created_at}}</div>
                                                    <div class="noticeContent">{{userInfo.userNotice.lastNoReadNotice.noticeContent}}</div>
                                                </div>
                                            </div>
                                            <div style="display: flex; align-items: center; padding-top: 20px;justify-content: center;" v-else>
                                                暂无更多~
                                            </div>
                                        </TabPane>
                                        <TabPane label="已读通知" name="name2">
                                            <div style="display: flex; align-items: center; margin-bottom: 20px;" v-if="userInfo.userNotice.lastReadNotice.noticeContent">
                                                <img :src="userInfo.userNotice.lastReadNotice.logo"
                                                     style="width: 40px;"/>
                                                <div style="margin-left: 10px;">
                                                    <div>{{userInfo.userNotice.lastReadNotice.created_at}}</div>
                                                    <div class="noticeContent">{{userInfo.userNotice.lastReadNotice.noticeContent}}</div>
                                                </div>
                                            </div>
                                            <div style="display: flex; align-items: center; padding-top: 20px;justify-content: center;" v-else>
                                                暂无更多~
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                    <span style="position: absolute; top: 8px; right: 120px; color: #54A1F3"  @click="allRead">全部已读</span>
                                    <Button style="position: absolute; top: 0; right: 20px;" type="primary" @click="informClick">更多通知</Button>
                                </div>
                            </div>
                        </Poptip>
                        <a class="margin_flex" href="javascript:void(0)" v-if="userInfo.menuList.homePage.helpCenter" @click="helpCenterClick"><span class="icon iconfont icon-wenhao"></span></a>
                        <Poptip placement="bottom" width="400">
                            <a href="javascript:void(0)"><span class="icon iconfont icon-caidan"></span></a>
                            <div class="api" slot="content">
                                <span @click="clientClick">全部客户</span>
                                <span @click="rankingClick">业绩排行榜</span>
                                <span @click="toolClick">工具</span>
<!--                                <span @click="workReportClick" v-if="userInfo.menuList.homePage.workReport" >工作汇报</span>-->
                            </div>
                        </Poptip>
<!--                        <a class="shezhia" v-if="userInfo.menuList.homePage.upgrade" href="javascript:void(0)" @click="upGradeClick"><span class="btn01">升级</span></a>-->
                        <i-switch class="margin_flex" style="margin-bottom: 5px" v-if="userInfo.set_open" v-model="userInfo.data_open"  @on-change="dataOpen">
                            <span slot="open">开</span>
                            <span slot="close">关</span>
                        </i-switch>
                    </div>
                    <Dropdown @on-click="selectSetting">
                        <a href="javascript:void(0)">
                            <span class="icon iconfont icon-shezhi"></span>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item v-if="userInfo.menuList.homePage && userInfo.menuList.homePage.teamRole" name="roleAuthority">角色权限</Dropdown-item>
                            <Dropdown-item v-if="userInfo.menuList.homePage && userInfo.menuList.homePage.organizationMember" name="tissueMember">组织成员</Dropdown-item>
                            <Dropdown-item v-if="userInfo.menuList.homePage && userInfo.menuList.homePage.talentPool" name="talentPool">人才库</Dropdown-item>
                            <Dropdown-item v-if="userInfo.menuList.homePage && userInfo.menuList.homePage.departmentManage" name="sectorSetup">业务设置</Dropdown-item>
                            <Dropdown-item name="logout">退出登录</Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                    <div class="userInfoArea">
                        <a href="javascript:void(0)" @click="myCenterClick">
                            <img style="width: 50px; height: 50px; vertical-align: middle; border-radius: 50%" :src="userInfo.ext_info.avatar"/>
                        </a>
                        <span>{{userInfo.name}}</span>
                    </div>
                </div>
            </Header>
            <Content :style="{ margin: '78px 20px 0', background: '#F5F7F9'}">
            </Content>
        </Layout>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {getMemberByDepartment, getUserBadgeCountInfo,allRead, getMyDepartmentList,setDataSetOpen} from '@/api/user.js';
    import {getMyShop} from "../../api/admin";
    export default {
        name: "TopBar",
        components: {},
        data() {
            return {
                tabsValue: '',
                activeMenu: '',
                iconShow: false,
                topShowName: '',
                shopList: [],
                departmentUserList: {},
                visible: false,
                userBadgeCountInfo: [],
                departmentList: [],
                departmentId: 0,
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'token'])
        },
        mounted: function () {
            this.activeMenu = this.$route.path.replace('/', '');
            this.loadData();
        },
        watch: {
            $route: function (route) {
                this.loadData();
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
                'getUserInfo',
            ]),
            toIndex() {
                if (this.userInfo.menuList.homePage) {
                    window.location.href = '#/homePage'
                }
            },
            async loadData() {
                let that = this;
                let data = {token: that.token};
                if (this.userInfo.role_type == 4 || this.userInfo.role_type == 5) {
                    let res = await getMyDepartmentList(that, data);
                    if (res.code == 1) {
                        that.tabsValue = 'department';
                        that.departmentList = res.data.list;
                        if (typeof window.localStorage['getTopDataDepartmentId'] != 'undefined' && window.localStorage['getTopDataDepartmentId'] != 0) {
                            res.data.list.forEach(function (row, index) {
                                if (row.id == window.localStorage['getTopDataDepartmentId']) {
                                    that.topShowName = res.data.list[index].name;
                                    that.departmentId = res.data.list[index].id;
                                    that.getDepartmentUserList();
                                    that.$EventBus.$emit("getHomeData");
                                }
                            })
                        } else {
                            that.topShowName = res.data.topShowName;
                            that.departmentId = res.data.list[0].id;
                            that.getDepartmentUserList();
                            window.localStorage.setItem('getTopDataDepartmentId', 0);
                            window.localStorage.setItem('getTopDataUserId', 0);
                            this.$EventBus.$emit("getHomeData");
                        }
                    }
                } else if (this.userInfo.role_type == 1 || this.userInfo.role_type == 2) {
                    let res = await getMyShop(that, data);
                    if (res.code == 1) {
                        that.tabsValue = 'shop';
                        that.shopList = res.data.list;
                        if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
                            res.data.list.forEach(function (row, index) {
                                if (row.id == window.localStorage['overallShopId']) {
                                    that.topShowName = res.data.list[index].name;
                                    that.$EventBus.$emit("getHomeData");
                                }
                            })
                        } else {
                            that.topShowName = this.userInfo.name;
                            window.localStorage.setItem('overallShopToken', '');
                            this.$EventBus.$emit("getHomeData");
                        }
                    }
                }
            },
            selectSetting(e) {
                if (e == 'logout') {
                    this.handleLogOut();
                    this.$router.push({
                        name: 'login'
                    })
                } else if (e == 'roleAuthority') {
                    window.open('#/roleAuthority')
                } else if (e == 'tissueMember') {
                    window.open('#/organizationMember')
                } else if (e == 'talentPool') {
                    window.open('#/talentPool')
                } else if (e == 'sectorSetup') {
                    window.open('#/SectorSetup')
                } else if (e == 'adminSet') {
                    window.open('#/adminSet')
                } else if (e == 'information') {
                    window.open('#/information')
                }
            },
            upGradeClick() {
                window.open('#/upgrade')
            },
            helpCenterClick() {
                window.open('#/helpcenter')
            },
            informClick() {
                window.open('#/informcenter')
            },
            // 个人中心
            myCenterClick() {
                window.open('#/myCenter')
            },
            // 工作汇报
            workReportClick() {
                window.open('#/workReport')
            },
            // 排行榜
            rankingClick() {
                this.$router.push({
                    name: 'statistics',
                    query: {menu: "performance_ranking"}
                })
            },
            //客户
            clientClick() {
                this.$router.push({
                    path: '/shop_client'
                })
            },
            //工具
            toolClick() {
                this.$router.push({
                    path: '/tool'
                })
            },
            selectFirstMenu(e) {
                this.topShowName = this.userInfo.name;
                this.$router.push({
                    path: '/' + e
                })
            },
            dataOpen(status) {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, index: status}
                    let res = await setDataSetOpen(that, data);
                    if (res.code == 1) {
                        that.getUserInfo();
                        that.$Message.success(res.msg);
                    }
                }, 500)
            },
            async getDepartmentUserList() {
                let that = this;
                let data = {token: that.token, id: this.departmentId}
                let res = await getMemberByDepartment(that, data);
                if (res.code == 1) {
                    that.departmentUserList = res.data.list;
                    if (typeof window.localStorage['getTopDataUserId'] != 'undefined' && window.localStorage['getTopDataUserId'] != 0) {
                        res.data.list.forEach(function (index, row) {
                            if (row.id == window.localStorage['getTopDataUserId']) {
                                that.topShowName = res.data.list[index].name;
                                this.$EventBus.$emit("getHomeData");
                            }
                        })
                    }
                }
            },
            chooseUser(e) {
                //获取个人统计
                let userId = e.currentTarget.dataset.id
                let userName = e.currentTarget.dataset.name;
                window.localStorage.setItem('getTopDataUserId', userId);
                this.$EventBus.$emit("getHomeData");
                this.topShowName = userName
                this.visible = false
            },
            chooseDepartment(e) {
                let departmentId = e.currentTarget.dataset.id
                let departmentName = e.currentTarget.dataset.name
                window.localStorage.setItem('getTopDataUserId', 0);
                window.localStorage.setItem('getTopDataDepartmentId', departmentId);
                this.$EventBus.$emit("getHomeData");
                this.topShowName = departmentName
                this.visible = false;
                this.departmentId = departmentId;
                this.getDepartmentUserList();
            },
            chooseShop(e) {
                let shopId = e.currentTarget.dataset.id;
                let shopToken = e.currentTarget.dataset.token
                let shopName = e.currentTarget.dataset.name
                this.topShowName = shopName
                window.localStorage.setItem('overallShopId', shopId);
                window.localStorage.setItem('overallShopToken', shopToken);
                this.$EventBus.$emit("getHomeData");
                this.visible = false;
            },
            allRead() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token}
                    let res = await allRead(that, data);
                    if (res.code == 1) {
                        that.getUserInfo();
                        that.$Message.success(res.msg);
                    }
                }, 500)
            },
        }
    }
</script>

<style scoped lang="less">
    .logo {
        width: 130px;
        height: 50px;
        margin-top: 5px;
    }

    .api {
        display: flex;
        justify-content: space-around;

        span {
            cursor: pointer;
        }

        span:hover {
            color: #277dd3;
        }
    }

    .icon-lingdang {
        height: 30px;
        display: block;
        line-height: 30px;
    }

    .shezhia {
        width: 50px;
        height: 30px;
        background-color: #277dd3;
        color: #fff;
        border-radius: 15px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;

    }

    .icon {
        font-size: 20px;
        font-weight: bold;
    }

    .icon-geren {
        font-size: 40px;
    }

    .top-right {
        min-width: 250px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .layout-top {
        /* border: 1px solid #d7dde4; */
        background: #FFFFFF;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .layout-nav {
        display: flex;
        justify-content: space-around;
        width: 700px;
        border: none;
    }

    .layout-footer-center {
        text-align: center;

    }

    .ivu-menu {
        display: flex;
        justify-content: center;
    }

    .btn01 {
        width: 50px;
        height: 30px;
        background-color: #277dd3;
        color: #fff;
        border-radius: 15px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
    }

    .ivu-layout-header {
        padding: 0 8%;
        display: flex;
        justify-content: space-between;
        border: 1px solid #DADCE0;

    }

    .ivu-menu-horizontal.ivu-menu-light:after {
        background-color: white;
    }

    a {
        color: #515A6E;
    }

    ivu-layout-content {
        margin: 0 100px;
    }

    .icon-down2, .icon-up {
        font-size: 16px;
        margin-left: 3px;
    }
    a:hover {
        color: #277dd3;
    }
    .userInfoArea{
        padding-left: 5px;
        width: 150px;
        display: flex;
        justify-content: space-between;
        span{
            padding-left: 5px;
            width: 100px;
            overflow: hidden; /*超出部分隐藏*/
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    /deep/ .my_badge{
        margin-top: 20px !important;
        margin-right: -15px !important;
    }
    .margin_flex{
        margin-left: 3px;
        margin-right: 3px;
    }
</style>
